import script from "./ResumeQualificationDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResumeQualificationDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ResumeQualificationDetail.vue?vue&type=style&index=0&id=30ab180e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ab180e"]])

export default __exports__